import classNames from 'classnames';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';

import { getLoggedIn } from '../app/redux/auth';
import ErrorBoundary from '../components/ErrorBoundary';
import { InnerContentScrollbars } from '../components/layout/InnerContentScrollbars';
import { Scrollbars } from '../components/layout/Scrollbars';
import { useScrollbarsStyles } from '../components/layout/Scrollbars.styles';
import Footer, { FooterTheme } from '../widgets/Footer';
import LoggedFooter from '../widgets/LoggedFooter';
import { useDetailPageStyles } from './DetailPage.styles';

export default function DetailPage({
  id,
  className,
  header,
  children,
  wrapInScrollbar,
}) {
  const { styles: scrollbarsStyles } = useScrollbarsStyles();
  const { styles } = useDetailPageStyles();
  const Wrapper = wrapInScrollbar ? InnerContentScrollbars : Fragment;
  const loggedIn = useSelector(getLoggedIn);

  return (
    <div className="fixed-full-screen">
      <Scrollbars id={id} className={classNames(styles.root, className)}>
        <div className={styles.content}>
          {header}
          <div
            className={classNames(
              styles.innerContent,
              scrollbarsStyles.detailPageMarker
            )}
          >
            <Wrapper>
              <ErrorBoundary messageId="error.render.page">
                {children}
              </ErrorBoundary>
            </Wrapper>
          </div>
          {loggedIn ? <LoggedFooter /> : <Footer theme={FooterTheme.DARK} />}
        </div>
      </Scrollbars>
    </div>
  );
}
